import {Component, Injector, Input} from '@angular/core';
import {FrontendFormComponent} from '@abstract/frontend.form.component';
import {WorkingObjectsStatusesProvider} from '@providers/working-objects-statuses/working-objects-statuses.provider';
import {ObjectsSetStatusApiService} from '../services/objects-set-status.api.service';

@Component({
    selector: 'app-objects-set-status-form',
    template: `
        <form [formGroup]="form" (ngSubmit)="save(form)">
            <app-form-group [fbControl]="form.get('status')" [width]="200">
                <app-form-label>Состояние</app-form-label>
                <app-form-select [fbControl]="form.get('status')" [values]="objectStatusesProvider.data$ | async"></app-form-select>
            </app-form-group>
            <app-button className="button-green">Сохранить</app-button>
        </form>
    `
})

export class ObjectsSetStatusFormComponent extends FrontendFormComponent {

    @Input() id: number;
    @Input() status: number;

    public afterSaveMessage = 'Состояние успешно изменено';

    public requestParams = {
        id: 0
    };

    constructor(
        injector: Injector,
        public objectStatusesProvider: WorkingObjectsStatusesProvider,
        public formService: ObjectsSetStatusApiService,
    ) {
        super(injector);
    }

    init() {
        this.form = this._fb.group({
            status: [this.status || '']
        });

        this.requestParams.id = this.id;
    }
}
